/* This is the new school building components update for 2022-2023 required 3 rows X 11cols */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 72px"
        border="1px;"
        width="850px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 135px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              ប្រភេទសំណង់
            </td>
            <td class="row-header65" rowspan="2">ចំនួនអគារ</td>
            <td class="row-header65" rowspan="2">ចំនួនបន្ទប់</td>
            <td
              style="
                width: 325px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="5"
            >
              ចំនួនបន្ទប់
            </td>
            <td
              style="
                width: 120px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              អាគារសាងសង់ថ្មី
            </td>
            <td
              style="
                width: 120px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              អាគារជួសជុលថ្មី
            </td>
          </tr>
          <tr>
            <td class="row-header65" rowspan="1">គ្មានកម្រាលល្អ</td>
            <td class="row-header65" rowspan="1">គ្មានដំបូលល្អ</td>
            <td class="row-header65" rowspan="1">គ្មានជញ្ជាំងល្អ</td>
            <td class="row-header65" rowspan="1">គ្មានបង្អួចល្អ</td>
            <td class="row-header65" rowspan="1">គ្មានទ្វារល្អ</td>
            <td class="row-header65">ចំនួនអគារ</td>
            <td class="row-header65">ចំនួនបន្ទប់</td>
            <td class="row-header65">ចំនួនអគារ</td>
            <td class="row-header65">ចំនួនបន្ទប់</td>
          </tr>
          <!-- This is data row -->
          <tr v-for="(value, row) in e2n.length - 1" :key="row">
            <td class="row-title">{{ e2n[row] }}</td>
            <td
              v-for="(value, col) in data[row].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[row].dt[col]" class="number" />
            </td>
          </tr>
          <!-- This is summary row -->
          <tr>
            <td class="row-title">
              <strong>{{ e2n[3] }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[0] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[1] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[2] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[3] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[4] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[5] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[6] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[7] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[8] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[9] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ totalRow[10] | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { e2n } from "@/utils/ascf/commonConfig.js";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      e2n: e2n,
    };
  },
  computed: {
    // update the total building in json data
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length - 1;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.row-header80 {
  width: 80px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header65 {
  width: 65px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.v-input {
  font-size: 12px;
}
.row-title {
  width: 135px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
.row-data {
  width: 65px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.number {
  width: 60px;
  text-align: center;
}
</style>